import * as React from "react";

import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";

// The release stamp ("<branch> <git describe>") is written into index.html by
// HtmlRspackPlugin rather than compiled into the bundle. Reading it from the
// document keeps every JS module byte-identical across commits, which is what
// lets the Rspack persistent cache survive a commit.
function releaseStamp() {
  const meta = document.querySelector<HTMLMetaElement>(
    'meta[name="wib-release"]'
  );
  return meta?.content || "unknown";
}

export const bugsnagClient = Bugsnag.start({
  apiKey: "f0546c7f9b254d669b7fa43178bd1e04",
  appVersion: releaseStamp(),
  plugins: [new BugsnagPluginReact()]
});

export const BugsnagErrorBoundary = bugsnagClient
  .getPlugin("react")
  .createErrorBoundary(React);
